import FloatingDatePicker from './FloatingDatePicker'

export default FloatingDatePicker
